<div class="flex gap-2 w-full">
	@for (button of actionButtons(); track button.id) {
		<ui-button
			[type]="'button'"
			[attr.data-cy]="button.cyTag"
			[variant]="button.variant"
			[class]="button.class"
			[extraButtonClasses]="button.class"
			[disabled]="button.disabled || isRequestLoading()"
			[loading]="isRequestLoading()"
			(click)="onButtonClick(button)">
			{{ button.label }}
		</ui-button>
	}
</div>

<app-commodity-access-denied-bottom-sheet #accessDeniedSheet />

<app-bottom-sheet
	#orderConfirmSheet
	ariaLabel="تایید سفارش"
	ariaLabelledBy="order-confirm-title"
	(closed)="onConfirmClosed()">
	<ng-template #body>
		@if (confirmSummary(); as summary) {
			<app-order-confirm
				[summary]="summary"
				[loading]="isRequestLoading()"
				(confirmed)="onConfirm()"
				(cancelled)="onCancelConfirm()" />
		}
	</ng-template>
</app-bottom-sheet>
